import { IBaseInitialState } from '../../interfaces/initialState'

export const baseInitialState: IBaseInitialState = {
  loading: false,
  error: false,
  success: false,
  message: null
}
